// ChangePassword.jsx
// Restyled to match KinetiQ design system.
// Uses Navbar (activePage="app") + Sidebar for the app shell.
// Same card shell + form token pattern as EditAccount.

import React, { useState } from 'react';
import axios from 'axios';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import { toast } from 'react-toastify';
import '../styles/ChangePassword.css';

const ChangePassword = () => {
  const [form, setForm] = useState({
    old_password:     '',
    new_password:     '',
    confirm_password: '',
  });

  const handleChange = (e) => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (form.new_password !== form.confirm_password) {
      toast.error('New passwords do not match.');
      return;
    }

    const token = localStorage.getItem('token');
    try {
      await axios.put(
        'https://www.kinetiqmodel.com/api/account/password',
        form,
        { headers: { Authorization: token } }
      );
      toast.success('Password changed successfully');
      setForm({ old_password: '', new_password: '', confirm_password: '' });
    } catch (err) {
      toast.error(err.response?.data?.error || 'Password change failed. Please try again.');
    }
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden', width: '100%' }}>

      <Sidebar />

      <div style={{
        marginLeft:    '220px',
        width:         'calc(100% - 220px)',
        display:       'flex',
        flexDirection: 'column',
        height:        '100vh',
        overflow:      'hidden',
      }}>

        <Navbar activePage="app" />

        <div style={{
          flex:      1,
          marginTop: '68px',
          overflowY: 'auto',
          overflowX: 'hidden',
          minHeight: 0,
        }}>
      <div className="account-page">

        {/* ── Page header ── */}
        <div className="account-page-header">
          <span className="account-page-label">Security</span>
          <h1>Change Password</h1>
          <p>Choose a strong password to keep your KinetiQ account secure.</p>
        </div>

        {/* ── Card ── */}
        <div className="account-card">

          <div className="account-card-section-title">
            <span className="section-icon">🔒</span>
            Update Password
          </div>

          <form className="account-form" onSubmit={handleSubmit}>

            <div className="account-form-group">
              <label htmlFor="cp-old">Current password</label>
              <input
                id="cp-old"
                type="password"
                name="old_password"
                value={form.old_password}
                onChange={handleChange}
                placeholder="Enter your current password"
                required
                autoComplete="current-password"
              />
            </div>

            {/* Divider between old and new */}
            <div className="account-field-divider" />

            <div className="account-form-group">
              <label htmlFor="cp-new">New password</label>
              <input
                id="cp-new"
                type="password"
                name="new_password"
                value={form.new_password}
                onChange={handleChange}
                placeholder="Create a new password"
                required
                autoComplete="new-password"
              />
            </div>

            <div className="account-form-group">
              <label htmlFor="cp-confirm">Confirm new password</label>
              <input
                id="cp-confirm"
                type="password"
                name="confirm_password"
                value={form.confirm_password}
                onChange={handleChange}
                placeholder="Repeat your new password"
                required
                autoComplete="new-password"
              />
            </div>

            {/* Password strength hint */}
            <p className="account-field-note">
              Use at least 8 characters with a mix of letters, numbers, and symbols.
            </p>

            {/* Actions */}
            <div className="account-form-actions">
              <button type="submit" className="account-btn-danger">
                Update Password →
              </button>
            </div>

          </form>
        </div>

      </div>

        </div>   {/* end scrollable content */}
      </div>     {/* end rightCol */}
    </div>       
  );
};

export default ChangePassword;